import { Box, Button, Group, Text } from "@mantine/core";
import { modals } from "@mantine/modals";
import { IconCheck, IconX } from "@tabler/icons-react";
import { repositoryPos } from "../../../_base/_const/_constVar";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { MessageResponse } from "../../../model/MessageResponse";

const DeleteView = ({
  listId,
  onSuccess,
}: {
  listId: number[];
  onSuccess: any;
}) => {
  const handleDelete = async () => {
    const res = await repositoryPos.delete<MessageResponse<boolean>>(
      "/api/v1/TblVoucherDetail/delete",
      { ids: listId }
    );
    if (res)
      if (res.success) {
        NotificationExtension.Success("Xóa thành công !");
        onSuccess();
      } else NotificationExtension.Fails("Xóa thất bại !");
    modals.closeAll();
  };

  return (
    <Box size={"auto"}>
      <Text size="20px" mt={10} fw={500}>
        Bạn có chắc chắn muốn xóa vourcher này ?
      </Text>
      <Group justify="center" mt="lg">
        <Button
          type="button"
          color="gray"
          onClick={() => modals.closeAll()}
          leftSection={<IconX size={18} />}
        >
          Hủy
        </Button>
        <Button
          type="button"
          color="red"
          onClick={handleDelete}
          leftSection={<IconCheck size={18} />}
        >
          Xóa
        </Button>
      </Group>
    </Box>
  );
};

export default DeleteView;
